export const SERVICES_ERROR = 'SERVICES_ERROR';
export const SERVICES_REQUEST = 'SERVICES_REQUEST';
export const SERVICES_SUCCESS = 'SERVICES_SUCCESS';
export const SERVICES_STATUS_UPDATE = 'SERVICES_STATUS_UPDATE';
export const SERVICES_SET_FILTERS = 'SERVICES_SET_FILTERS';
